webpackJsonp([64],{

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      instructionGroups: []
    };
  },

  methods: {
    loadGroups: function loadGroups() {
      var _this = this;

      request.page('queryTrainingInstructionGroupAll').then(function (_ref) {
        var data = _ref.data;

        _this.instructionGroups = data.map(function (it) {
          return { value: it.id, label: it.name };
        });
      });
    },
    deleteInstructionGroup: function deleteInstructionGroup(item) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5220\u9664\u5206\u7EC4\u300C' + item.label + '\u300D\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        return request.common('deleteTrainingInstructionGroup', item.value);
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.onInstructionGroupDeleted(item);
        _this2.loadGroups();
      }).catch(function () {});
    },
    onInstructionGroupDeleted: function onInstructionGroupDeleted(item) {
      if (this.form && this.form.instruction_group_name === item.label) {
        this.form.instruction_group_name = null;
      }
      if (this.search && Number(this.search.instruction_group_id) === Number(item.value)) {
        this.search.instruction_group_id = null;
      }
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    }
  }
});

/***/ }),

/***/ 1665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return opts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY; });
var consts = {
  // 布尔值
  FALSE: 0,
  TRUE: 1,

  // 所属用户类型
  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  // 是否通用
  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  // 培训状态
  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,

  // 培训类型
  TYPE_ONLY_LEARNING: 1,
  TYPE_ONLY_EXAM: 2,
  TYPE_LEARNING_AND_EXAM: 3,

  // 考试状态
  EXAMINATION_STATUS_ONLINE: 2
};

var opts = {
  boolMaps: [{ value: consts.TRUE, label: '是' }, { value: consts.FALSE, label: '否' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }],
  typeMaps: [{ value: consts.TYPE_ONLY_LEARNING, label: '仅学习' }, { value: consts.TYPE_ONLY_EXAM, label: '仅考试' }, { value: consts.TYPE_LEARNING_AND_EXAM, label: '学习+考试' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }]
};

var TRAINING_INSTRUCTION_TABLE_COLUMN_STORAGE_KEY = 'training-instruction-list';

/***/ }),

/***/ 2119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return options; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isKnowledgeDialogEditLocked;
// initial state

var consts = {
  // 布尔值
  FALSE: 0,
  TRUE: 1,

  // 是否通用
  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  // 激活状态
  STATUS_NEW: 1,
  // 如要修改，请同步修改training-course.constants.js中的KNOWLEDGE_STATUS_ACTIVE常量
  STATUS_ACTIVE: 2,
  STATUS_BANNED: 3
};
var options = {
  IsCommonStatus: [{ value: consts.IS_COMMON_SHARED, label: '通用' }, { value: consts.IS_COMMON_DEDICATED, label: '专用' }],
  KnowledgeStatus: [{ value: consts.STATUS_ACTIVE, label: '已激活' }, { value: consts.STATUS_BANNED, label: '已作废' }],
  KnowledgeStatusTable: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ACTIVE, label: '已激活' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function isKnowledgeDialogEditLocked(id, status) {
  return Number(id) > 0 && Number(status) !== consts.STATUS_NEW;
}

/***/ }),

/***/ 3043:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__training_instruction_rules__ = __webpack_require__(5620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_training_training_knowledge_constants__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_training_components_TrainingKnowledgeFormDialog_vue__ = __webpack_require__(5621);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TrainingKnowledgeFormDialog: __WEBPACK_IMPORTED_MODULE_9__views_training_components_TrainingKnowledgeFormDialog_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__views_training_training_mixins__["a" /* default */]],
  data: function data() {
    return {
      id: 0,
      formExpanded: true,
      submitting: false,
      detailLoading: false,
      coverUploading: false,
      opts: __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["c" /* opts */],
      consts: __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */],
      courseConsts: __WEBPACK_IMPORTED_MODULE_7__views_training_training_course_constants__["b" /* consts */],
      form: {
        title: '',
        cover_imgs: [],
        target_usertype: 1,
        display_in_app_learning_center: 1,
        priority: 0,
        instruction_group_name: null,
        retraining_days: 0,
        is_common: 0,
        customerid: null,
        training_knowledge_id: null,
        instruction_type: null,
        training_course_id: null,
        training_examination_id: null,
        instruction_status: __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].STATUS_NEW
      }
    };
  },

  computed: {
    pageTitle: function pageTitle() {
      return this.id ? '编辑培训' : '创建培训';
    },
    submitButtonText: function submitButtonText() {
      return this.id ? '保存修改' : '创建培训';
    },
    formRules: function formRules() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__training_instruction_rules__["a" /* createFormRules */])(this.form), Object(__WEBPACK_IMPORTED_MODULE_4__training_instruction_rules__["b" /* createRelatedRules */])(this.needsCourse, this.needsExam));
    },
    coverPreviewUrl: function coverPreviewUrl() {
      var cover = this.form.cover_imgs[0];
      return cover && cover.url ? cover.url : '';
    },
    isContentConfigLocked: function isContentConfigLocked() {
      return this.id > 0 && Number(this.form.instruction_status) !== __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].STATUS_NEW;
    },
    isWorkerUser: function isWorkerUser() {
      return Number(this.form.target_usertype) === __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TARGETUSER_TYPE_USER;
    },
    showLearningCenterGroup: function showLearningCenterGroup() {
      return this.isWorkerUser && Number(this.form.display_in_app_learning_center) === __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TRUE;
    },
    needsCourse: function needsCourse() {
      return [__WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TYPE_ONLY_LEARNING, __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TYPE_LEARNING_AND_EXAM].includes(Number(this.form.instruction_type));
    },
    needsExam: function needsExam() {
      return [__WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TYPE_ONLY_EXAM, __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TYPE_LEARNING_AND_EXAM].includes(Number(this.form.instruction_type));
    },
    knowledgeQueryParams: function knowledgeQueryParams() {
      var params = {
        status: __WEBPACK_IMPORTED_MODULE_6__views_training_training_knowledge_constants__["a" /* consts */].STATUS_ACTIVE,
        is_common: this.form.is_common
      };
      if (Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].IS_COMMON_DEDICATED && this.form.customerid) {
        params.customerid = this.form.customerid;
      }
      return params;
    },
    relatedContentQueryParams: function relatedContentQueryParams() {
      var params = {
        target_usertype: this.form.target_usertype,
        is_common: this.form.is_common
      };
      if (this.form.training_knowledge_id) {
        params.training_knowledge_id = this.form.training_knowledge_id;
      }
      if (Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].IS_COMMON_DEDICATED && this.form.customerid) {
        params.customerid = this.form.customerid;
      }
      return params;
    }
  },
  created: function created() {
    this.onLoad();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request.map(['getBasicCustomerTable', 'getBasicCustomerDetail', 'queryTrainingKnowledge', 'getTrainingKnowledge', 'queryUserTrainingCourse', 'getTrainingCourse', 'queryTrainingExamination', 'getTrainingExamination', 'getTrainingSignedOssUrl']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.id = Number(this.$route.params.id);
        this.loadDetail(this.id);
      }
      this.loadGroups();
    },
    openRouteInNewTab: function openRouteInNewTab(route) {
      var routeData = this.$router.resolve(route);
      window.open(routeData.href, '_blank');
    },
    openKnowledgeDialog: function openKnowledgeDialog() {
      if (Number(this.form.is_common) === __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].IS_COMMON_DEDICATED && !this.form.customerid) {
        this.$message.warning('请先选择所属客户');
        return;
      }
      this.$refs.knowledgeDialog.openCreate({
        is_common: this.form.is_common,
        customerid: this.form.customerid
      });
    },
    onKnowledgeCreated: function onKnowledgeCreated(payload) {
      if (payload && payload.id) {
        this.form.training_knowledge_id = Number(payload.id);
        this.$refs.form && this.$refs.form.validateField('training_knowledge_id');
      }
    },
    goCreateCourse: function goCreateCourse() {
      this.openRouteInNewTab({ path: '/training/user-course/create' });
    },
    goCreateExamination: function goCreateExamination() {
      this.openRouteInNewTab({ path: '/training/examination/create' });
    },
    loadDetail: function loadDetail(id) {
      var _this = this;

      this.detailLoading = true;
      request.common('getTrainingInstruction', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
        _this.form.is_common = Number(_this.form.is_common);
        _this.form.cover_imgs = Array.isArray(data.cover_imgs) ? data.cover_imgs : [];
        _this.form.customerid = data.customerid > 0 ? String(data.customerid) : null;
        _this.form.training_course_id = data.training_course_id > 0 ? data.training_course_id : null;
        _this.form.training_examination_id = data.training_examination_id > 0 ? data.training_examination_id : null;
      }).catch(function () {
        _this.$message.error('培训详情加载失败');
      }).finally(function () {
        _this.detailLoading = false;
      });
    },
    onTargetUsertypeChanged: function onTargetUsertypeChanged(value) {
      if (Number(value) === __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TARGETUSER_TYPE_INTERN) {
        this.form.display_in_app_learning_center = __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].FALSE;
        this.form.instruction_group_name = null;
      }
      this.onContentConfigChanged();
    },
    onDisplayInAppChanged: function onDisplayInAppChanged(value) {
      if (Number(value) !== __WEBPACK_IMPORTED_MODULE_5__views_training_training_instruction_constants__["b" /* consts */].TRUE) {
        this.form.instruction_group_name = null;
      }
    },
    onIsCommonChanged: function onIsCommonChanged(value) {
      if (Number(value) === 1) {
        this.form.customerid = null;
      }
      this.onContentConfigChanged();
    },
    onInstructionTypeChanged: function onInstructionTypeChanged() {
      if (!this.needsCourse) {
        this.form.training_course_id = null;
      }
      if (!this.needsExam) {
        this.form.training_examination_id = null;
      }
    },
    onContentConfigChanged: function onContentConfigChanged() {
      this.form.training_knowledge_id = null;
      this.form.training_course_id = null;
      this.form.training_examination_id = null;
      if (!this.isWorkerUser) {
        this.form.instruction_group_name = null;
      }
    },
    onCoverChange: function onCoverChange(file) {
      var raw = file.raw;
      if (!raw) {
        return;
      }
      var allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(raw.type)) {
        this.$message.error('请上传 jpg/png 图片');
        this.$refs.coverUpload && this.$refs.coverUpload.clearFiles();
        return;
      }
      if (raw.size / 1024 / 1024 > 20) {
        this.$message.error('图片大小不能超过 20MB');
        this.$refs.coverUpload && this.$refs.coverUpload.clearFiles();
        return;
      }
      this.uploadCover(raw);
    },
    uploadCover: function uploadCover(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ext, _ref2, data, uploadRes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.coverUploading = true;
                _context.prev = 1;
                ext = file.name.split('.').pop().toLowerCase();
                _context.next = 5;
                return request.common('getTrainingSignedOssUrl', {
                  file_name: file.name,
                  ext: ext,
                  content_type: file.type
                });

              case 5:
                _ref2 = _context.sent;
                data = _ref2.data;
                _context.next = 9;
                return fetch(data.signedUrl, {
                  method: 'PUT',
                  headers: { 'Content-Type': data.content_type },
                  body: file
                });

              case 9:
                uploadRes = _context.sent;

                if (uploadRes.ok) {
                  _context.next = 13;
                  break;
                }

                _this2.$message.error('\u4E0A\u4F20\u5931\u8D25: ' + uploadRes.status);
                return _context.abrupt('return');

              case 13:
                _this2.form.cover_imgs = [{
                  name: file.name,
                  url: data.url,
                  uid: Date.now(),
                  size: file.size
                }];
                _this2.$refs.form && _this2.$refs.form.validateField('cover_imgs');
                _this2.$message.success('封面上传成功');
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](1);

                _this2.$message.error(_context.t0.message || '封面上传失败');
                _this2.$refs.coverUpload && _this2.$refs.coverUpload.clearFiles();

              case 22:
                _context.prev = 22;

                _this2.coverUploading = false;
                return _context.finish(22);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 18, 22, 25]]);
      }))();
    },
    removeCover: function removeCover() {
      this.form.cover_imgs = [];
      this.$refs.coverUpload && this.$refs.coverUpload.clearFiles();
      this.$refs.form && this.$refs.form.validateField('cover_imgs');
    },
    getSubmitPayload: function getSubmitPayload() {
      var payload = filter.copyJson(this.form);
      if (Number(payload.is_common) === 1) {
        payload.customerid = 0;
      }
      if (!this.needsCourse) {
        payload.training_course_id = 0;
      }
      if (!this.needsExam) {
        payload.training_examination_id = 0;
      }
      delete payload.instruction_status;
      return payload;
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this3.$message.error('请检查表单填写是否正确');
          return;
        }
        _this3.submitting = true;
        var requestName = _this3.id ? 'updateTrainingInstruction' : 'createTrainingInstruction';
        var params = _this3.id ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ id: _this3.id }, _this3.getSubmitPayload()) : _this3.getSubmitPayload();
        request.common(requestName, params).then(function () {
          _this3.$message.success(_this3.id ? '保存成功' : '创建成功');
          _this3.$router.push({ path: '/training/instruction' });
        }).finally(function () {
          _this3.submitting = false;
        });
      });
    }
  })
});

/***/ }),

/***/ 3044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_training_knowledge_constants__ = __webpack_require__(2119);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DEFAULT_FORM = function DEFAULT_FORM() {
  return {
    name: '',
    is_common: 1,
    customerid: null
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingKnowledgeFormDialog',
  data: function data() {
    var _this = this;

    return {
      consts: __WEBPACK_IMPORTED_MODULE_2__views_training_training_knowledge_constants__["a" /* consts */],
      dialogVisible: false,
      dialogTitle: '',
      dialogId: 0,
      dialogStatus: __WEBPACK_IMPORTED_MODULE_2__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW,
      saving: false,
      dialogForm: DEFAULT_FORM(),
      dialogRules: {
        name: [{ required: true, message: '请输入知识库名称', trigger: 'blur' }],
        is_common: [{ required: true, message: '请选择是否通用', trigger: 'change' }],
        customerid: [{
          validator: function validator(rule, value, callback) {
            if (Number(_this.dialogForm.is_common) === 0 && !value) {
              callback(new Error('请选择客户'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }]
      }
    };
  },

  computed: {
    isDialogEditLocked: function isDialogEditLocked() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__views_training_training_knowledge_constants__["b" /* isKnowledgeDialogEditLocked */])(this.dialogId, this.dialogStatus);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'getTrainingKnowledgeDetail']), {
    openCreate: function openCreate() {
      var prefill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.dialogTitle = '新增知识库';
      this.dialogId = 0;
      this.dialogStatus = __WEBPACK_IMPORTED_MODULE_2__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW;
      this.resetDialogForm(prefill);
      this.dialogVisible = true;
    },
    openEdit: function openEdit(id) {
      var _this2 = this;

      request.loading('getTrainingKnowledgeDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this2.dialogTitle = '修改知识库';
        _this2.dialogId = Number(id);
        _this2.dialogStatus = Number(data.status) || __WEBPACK_IMPORTED_MODULE_2__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW;
        _this2.dialogForm = {
          name: data.name,
          is_common: Number(data.is_common),
          customerid: data.customerid ? String(data.customerid) : null
        };
        _this2.dialogVisible = true;
        _this2.handleDialogIsCommonChange(_this2.dialogForm.is_common);
      });
    },
    resetDialogForm: function resetDialogForm() {
      var _this3 = this;

      var prefill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.dialogForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(DEFAULT_FORM(), {
        is_common: prefill.is_common != null ? Number(prefill.is_common) : 1,
        customerid: prefill.customerid ? String(prefill.customerid) : null
      });
      this.$nextTick(function () {
        if (_this3.$refs.dialogForm) {
          _this3.$refs.dialogForm.clearValidate();
        }
      });
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },
    handleDialogClosed: function handleDialogClosed() {
      this.dialogId = 0;
      this.dialogStatus = __WEBPACK_IMPORTED_MODULE_2__views_training_training_knowledge_constants__["a" /* consts */].STATUS_NEW;
      this.saving = false;
      this.resetDialogForm();
    },
    handleDialogIsCommonChange: function handleDialogIsCommonChange(value) {
      var _this4 = this;

      if (this.isDialogEditLocked) {
        return;
      }
      if (Number(value) === 1) {
        this.dialogForm.customerid = null;
      }
      this.$nextTick(function () {
        if (_this4.$refs.dialogForm) {
          _this4.$refs.dialogForm.clearValidate('customerid');
        }
      });
    },
    getDialogSubmitData: function getDialogSubmitData() {
      var isCommon = Number(this.dialogForm.is_common);
      return {
        id: this.dialogId,
        name: this.dialogForm.name,
        is_common: isCommon,
        customerid: isCommon === 1 ? 0 : this.dialogForm.customerid
      };
    },
    saveTrainingKnowledge: function saveTrainingKnowledge() {
      var _this5 = this;

      this.$refs.dialogForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        var apiName = _this5.dialogId ? 'updateTrainingKnowledge' : 'createTrainingKnowledge';
        _this5.saving = true;
        request.loading(apiName, _this5.getDialogSubmitData()).then(function (_ref2) {
          var data = _ref2.data;

          _this5.$message.success('保存成功');
          var createdId = _this5.dialogId || data && (data.id || data);
          var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this5.getDialogSubmitData(), {
            id: createdId
          });
          _this5.$emit('success', payload);
          _this5.closeDialog();
        }).finally(function () {
          _this5.saving = false;
        });
      });
    }
  })
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionForm_vue__ = __webpack_require__(3043);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcac3756_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionForm_vue__ = __webpack_require__(5625);
function injectStyle (ssrContext) {
  __webpack_require__(5616)
  __webpack_require__(5618)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dcac3756"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingInstructionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcac3756_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingInstructionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5616:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("ec9367ec", content, true, {});

/***/ }),

/***/ 5617:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-form__card[data-v-dcac3756]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.training-instruction-form__card-header[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.training-instruction-form__card-header i[data-v-dcac3756]{color:#909399}.training-instruction-form__body[data-v-dcac3756]{padding:20px 24px 0}.training-instruction-form__section+.training-instruction-form__section[data-v-dcac3756]{margin-top:24px}.training-instruction-form__section-title[data-v-dcac3756]{margin:0 0 16px;padding-bottom:8px;border-bottom:1px solid #ebeef5;color:#303133;font-size:16px;font-weight:600;line-height:1.5}.training-instruction-form__row[data-v-dcac3756]{display:grid;grid-template-columns:minmax(120px,16.666%) minmax(0,1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:16px}.training-instruction-form__label[data-v-dcac3756]{padding-top:8px;color:#606266;font-size:14px;line-height:1.5}.training-instruction-form__label.is-required[data-v-dcac3756]:before{content:\"*\";color:#f56c6c;margin-right:4px}.training-instruction-form__field[data-v-dcac3756]{min-width:0}.training-instruction-form__field-with-action[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px}.training-instruction-form__field-with-action .width-max[data-v-dcac3756]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.training-instruction-form__field-action[data-v-dcac3756]{-ms-flex-negative:0;flex-shrink:0;padding:4px;margin-top:2px;font-size:18px;color:#409eff;line-height:1}.training-instruction-form__field-action[data-v-dcac3756]:focus,.training-instruction-form__field-action[data-v-dcac3756]:hover{color:#66b1ff}.training-instruction-form__form-item[data-v-dcac3756]{margin-bottom:0}.training-instruction-form__number-input[data-v-dcac3756]{width:160px}.training-instruction-form__inline-number[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.training-instruction-form__inline-suffix[data-v-dcac3756]{color:#909399;font-size:14px}.training-instruction-form__cover-uploader ::v-deep .el-upload[data-v-dcac3756],.training-instruction-form__cover-uploader[data-v-dcac3756]{width:100%}.training-instruction-form__cover-uploader ::v-deep .el-upload-dragger[data-v-dcac3756]{width:100%;height:auto;min-height:160px;padding:0;border:2px dashed #dcdfe6;border-radius:8px;background:#fafafa;-webkit-transition:border-color .2s ease;transition:border-color .2s ease}.training-instruction-form__cover-uploader ::v-deep .el-upload-dragger[data-v-dcac3756]:hover{border-color:#409eff}.training-instruction-form__cover-placeholder[data-v-dcac3756]{padding:36px 24px;text-align:center}.training-instruction-form__cover-placeholder .el-icon-upload[data-v-dcac3756]{font-size:32px;color:#c0c4cc;margin-bottom:8px}.training-instruction-form__cover-placeholder-text[data-v-dcac3756]{color:#909399;font-size:14px;line-height:1.6}.training-instruction-form__cover-placeholder-tip[data-v-dcac3756]{margin-top:4px;color:#c0c4cc;font-size:12px;line-height:1.5}.training-instruction-form__cover-preview[data-v-dcac3756]{position:relative;width:100%;max-width:686px;aspect-ratio:686/292;background:#f5f7fa}.training-instruction-form__cover-preview img[data-v-dcac3756]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block}.training-instruction-form__cover-actions[data-v-dcac3756]{position:absolute;right:8px;bottom:8px;background:hsla(0,0%,100%,.92);border-radius:4px;padding:0 4px}.training-instruction-form__footer[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:12px;margin:8px -24px 0;padding:12px 24px;background:#f5f7fa;border-top:1px solid #ebeef5;border-radius:0 0 8px 8px}.field-tip[data-v-dcac3756]{margin-top:4px;color:#909399;font-size:12px;line-height:1.5}.content-lock-alert[data-v-dcac3756]{margin-bottom:16px}@media (max-width:768px){.training-instruction-form__row[data-v-dcac3756]{grid-template-columns:1fr;gap:8px}.training-instruction-form__label[data-v-dcac3756]{padding-top:0}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/instruction/TrainingInstructionForm.vue"],"names":[],"mappings":"AACA,kDAAkD,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CACtL,AACD,yDAAyD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CAC9b,AACD,2DAA2D,aAAa,CACvE,AACD,kDAAkD,mBAAmB,CACpE,AACD,yFAAyF,eAAe,CACvG,AACD,2DAA2D,gBAAgB,mBAAmB,gCAAgC,cAAc,eAAe,gBAAgB,eAAe,CACzL,AACD,iDAAiD,aAAa,0DAA4D,SAAS,wBAAwB,qBAAqB,kBAAkB,kBAAkB,CACnN,AACD,mDAAmD,gBAAgB,cAAc,eAAe,eAAe,CAC9G,AACD,sEAAuE,YAAY,cAAc,gBAAgB,CAChH,AACD,mDAAmD,WAAW,CAC7D,AACD,+DAA+D,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,OAAO,CAC9L,AACD,0EAA0E,mBAAmB,WAAW,OAAO,WAAW,CACzH,AACD,0DAA0D,oBAAoB,cAAc,YAAY,eAAe,eAAe,cAAc,aAAa,CAChK,AACD,gIAAgI,aAAa,CAC5I,AACD,uDAAuD,eAAe,CACrE,AACD,0DAA0D,WAAW,CACpE,AACD,2DAA2D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CACxL,AACD,2DAA2D,cAAc,cAAc,CACtF,AAGD,4IAAgF,UAAU,CACzF,AACD,wFAAwF,WAAW,YAAY,iBAAiB,UAAU,0BAA0B,kBAAkB,mBAAmB,yCAA0C,gCAAiC,CACnR,AACD,8FAA8F,oBAAoB,CACjH,AACD,+DAA+D,kBAAkB,iBAAiB,CACjG,AACD,+EAA+E,eAAe,cAAc,iBAAiB,CAC5H,AACD,oEAAoE,cAAc,eAAe,eAAe,CAC/G,AACD,mEAAmE,eAAe,cAAc,eAAe,eAAe,CAC7H,AACD,2DAA2D,kBAAkB,WAAW,gBAAgB,qBAAuB,kBAAkB,CAChJ,AACD,+DAA+D,WAAW,YAAY,oBAAoB,iBAAiB,aAAa,CACvI,AACD,2DAA2D,kBAAkB,UAAU,WAAW,+BAAkC,kBAAkB,aAAa,CAClK,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,qBAAqB,kBAAkB,yBAAyB,SAAS,mBAAmB,kBAAkB,mBAAmB,6BAA6B,yBAAyB,CAC/R,AACD,4BAA4B,eAAe,cAAc,eAAe,eAAe,CACtF,AACD,qCAAqC,kBAAkB,CACtD,AACD,yBACA,iDAAiD,0BAA0B,OAAO,CACjF,AACD,mDAAmD,aAAa,CAC/D,CACA","file":"TrainingInstructionForm.vue","sourcesContent":["\n.training-instruction-form__card[data-v-dcac3756]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.training-instruction-form__card-header[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.training-instruction-form__card-header i[data-v-dcac3756]{color:#909399\n}\n.training-instruction-form__body[data-v-dcac3756]{padding:20px 24px 0\n}\n.training-instruction-form__section+.training-instruction-form__section[data-v-dcac3756]{margin-top:24px\n}\n.training-instruction-form__section-title[data-v-dcac3756]{margin:0 0 16px;padding-bottom:8px;border-bottom:1px solid #ebeef5;color:#303133;font-size:16px;font-weight:600;line-height:1.5\n}\n.training-instruction-form__row[data-v-dcac3756]{display:grid;grid-template-columns:minmax(120px, 16.666%) minmax(0, 1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:16px\n}\n.training-instruction-form__label[data-v-dcac3756]{padding-top:8px;color:#606266;font-size:14px;line-height:1.5\n}\n.training-instruction-form__label.is-required[data-v-dcac3756]::before{content:'*';color:#f56c6c;margin-right:4px\n}\n.training-instruction-form__field[data-v-dcac3756]{min-width:0\n}\n.training-instruction-form__field-with-action[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px\n}\n.training-instruction-form__field-with-action .width-max[data-v-dcac3756]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.training-instruction-form__field-action[data-v-dcac3756]{-ms-flex-negative:0;flex-shrink:0;padding:4px;margin-top:2px;font-size:18px;color:#409eff;line-height:1\n}\n.training-instruction-form__field-action[data-v-dcac3756]:hover,.training-instruction-form__field-action[data-v-dcac3756]:focus{color:#66b1ff\n}\n.training-instruction-form__form-item[data-v-dcac3756]{margin-bottom:0\n}\n.training-instruction-form__number-input[data-v-dcac3756]{width:160px\n}\n.training-instruction-form__inline-number[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.training-instruction-form__inline-suffix[data-v-dcac3756]{color:#909399;font-size:14px\n}\n.training-instruction-form__cover-uploader[data-v-dcac3756]{width:100%\n}\n.training-instruction-form__cover-uploader ::v-deep .el-upload[data-v-dcac3756]{width:100%\n}\n.training-instruction-form__cover-uploader ::v-deep .el-upload-dragger[data-v-dcac3756]{width:100%;height:auto;min-height:160px;padding:0;border:2px dashed #dcdfe6;border-radius:8px;background:#fafafa;-webkit-transition:border-color 0.2s ease;transition:border-color 0.2s ease\n}\n.training-instruction-form__cover-uploader ::v-deep .el-upload-dragger[data-v-dcac3756]:hover{border-color:#409eff\n}\n.training-instruction-form__cover-placeholder[data-v-dcac3756]{padding:36px 24px;text-align:center\n}\n.training-instruction-form__cover-placeholder .el-icon-upload[data-v-dcac3756]{font-size:32px;color:#c0c4cc;margin-bottom:8px\n}\n.training-instruction-form__cover-placeholder-text[data-v-dcac3756]{color:#909399;font-size:14px;line-height:1.6\n}\n.training-instruction-form__cover-placeholder-tip[data-v-dcac3756]{margin-top:4px;color:#c0c4cc;font-size:12px;line-height:1.5\n}\n.training-instruction-form__cover-preview[data-v-dcac3756]{position:relative;width:100%;max-width:686px;aspect-ratio:686 / 292;background:#f5f7fa\n}\n.training-instruction-form__cover-preview img[data-v-dcac3756]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block\n}\n.training-instruction-form__cover-actions[data-v-dcac3756]{position:absolute;right:8px;bottom:8px;background:rgba(255,255,255,0.92);border-radius:4px;padding:0 4px\n}\n.training-instruction-form__footer[data-v-dcac3756]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:12px;margin:8px -24px 0;padding:12px 24px;background:#f5f7fa;border-top:1px solid #ebeef5;border-radius:0 0 8px 8px\n}\n.field-tip[data-v-dcac3756]{margin-top:4px;color:#909399;font-size:12px;line-height:1.5\n}\n.content-lock-alert[data-v-dcac3756]{margin-bottom:16px\n}\n@media (max-width: 768px){\n.training-instruction-form__row[data-v-dcac3756]{grid-template-columns:1fr;gap:8px\n}\n.training-instruction-form__label[data-v-dcac3756]{padding-top:0\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5618:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5619);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5be3d910", content, true, {});

/***/ }),

/***/ 5619:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-instruction-form__cover-uploader .el-upload-dragger.is-dragover{border-color:#409eff}.training-instruction-group-select .instruction-group-option{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%;gap:8px}.training-instruction-group-select .instruction-group-option__label{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.training-instruction-group-select .instruction-group-option__delete{-ms-flex-negative:0;flex-shrink:0;padding:0 4px;color:#f56c6c}.training-instruction-group-select .instruction-group-option__delete:focus,.training-instruction-group-select .instruction-group-option__delete:hover{color:#f78989}", "", {"version":3,"sources":["/workspace/src/views/training/pages/instruction/TrainingInstructionForm.vue"],"names":[],"mappings":"AACA,0EAA0E,oBAAoB,CAC7F,AACD,6DAA6D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,WAAW,OAAO,CAClR,AACD,oEAAoE,mBAAmB,WAAW,OAAO,YAAY,gBAAgB,uBAAuB,kBAAkB,CAC7K,AACD,qEAAqE,oBAAoB,cAAc,cAAc,aAAa,CACjI,AACD,sJAAsJ,aAAa,CAClK","file":"TrainingInstructionForm.vue","sourcesContent":["\n.training-instruction-form__cover-uploader .el-upload-dragger.is-dragover{border-color:#409eff\n}\n.training-instruction-group-select .instruction-group-option{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%;gap:8px\n}\n.training-instruction-group-select .instruction-group-option__label{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.training-instruction-group-select .instruction-group-option__delete{-ms-flex-negative:0;flex-shrink:0;padding:0 4px;color:#f56c6c\n}\n.training-instruction-group-select .instruction-group-option__delete:hover,.training-instruction-group-select .instruction-group-option__delete:focus{color:#f78989\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRelatedRules; });
var validateCoverImgs = function validateCoverImgs(rule, value, callback) {
  if (!Array.isArray(value) || !value.length || !value[0].url) {
    callback(new Error('请上传封面图片'));
    return;
  }
  if (value.length > 1) {
    callback(new Error('封面图片最多1张'));
    return;
  }
  callback();
};

var validateCustomerid = function validateCustomerid(form) {
  return function (rule, value, callback) {
    if (Number(form.is_common) === 0 && !value) {
      callback(new Error('请选择所属客户'));
      return;
    }
    callback();
  };
};

var createFormRules = function createFormRules(form) {
  return {
    title: [{ required: true, message: '请输入标题' }, { max: 255, message: '标题最多255个字符' }],
    cover_imgs: [{ required: true, validator: validateCoverImgs }],
    target_usertype: [{ required: true, message: '请选择所属用户类型' }],
    display_in_app_learning_center: [{ required: true, message: '请选择是否在App展示' }],
    priority: [{ required: true, message: '请输入优先级' }],
    retraining_days: [{ required: true, message: '请输入重考间隔', trigger: 'blur' }],
    is_common: [{ required: true, message: '请选择是否通用', trigger: 'change' }],
    customerid: [{ validator: validateCustomerid(form), trigger: 'change' }],
    training_knowledge_id: [{ required: true, message: '请选择所属知识库', type: 'number' }],
    instruction_type: [{ required: true, message: '请选择类型', trigger: 'change' }]
  };
};

var createRelatedRules = function createRelatedRules(needsCourse, needsExam) {
  var rules = {};
  if (needsCourse) {
    rules.training_course_id = [{ required: true, message: '请选择关联教程', trigger: 'change' }];
  }
  if (needsExam) {
    rules.training_examination_id = [{ required: true, message: '请选择关联考试', trigger: 'change' }];
  }
  return rules;
};

/***/ }),

/***/ 5621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingKnowledgeFormDialog_vue__ = __webpack_require__(3044);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e93b6aac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingKnowledgeFormDialog_vue__ = __webpack_require__(5624);
function injectStyle (ssrContext) {
  __webpack_require__(5622)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e93b6aac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingKnowledgeFormDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e93b6aac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingKnowledgeFormDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5622:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("90725ed2", content, true, {});

/***/ }),

/***/ 5623:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".training-knowledge-form-dialog__tips[data-v-e93b6aac]{color:#8492a6;font-size:12px;line-height:20px}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingKnowledgeFormDialog.vue"],"names":[],"mappings":"AACA,uDAAuD,cAAc,eAAe,gBAAgB,CACnG","file":"TrainingKnowledgeFormDialog.vue","sourcesContent":["\n.training-knowledge-form-dialog__tips[data-v-e93b6aac]{color:#8492a6;font-size:12px;line-height:20px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.dialogTitle,"visible":_vm.dialogVisible,"width":"680px","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event},"closed":_vm.handleDialogClosed}},[_c('el-form',{ref:"dialogForm",attrs:{"model":_vm.dialogForm,"rules":_vm.dialogRules,"label-width":"150px"}},[_c('el-form-item',{attrs:{"label":"知识库名称","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入知识库名称","maxlength":"255","clearable":""},model:{value:(_vm.dialogForm.name),callback:function ($$v) {_vm.$set(_vm.dialogForm, "name", $$v)},expression:"dialogForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isDialogEditLocked},on:{"change":_vm.handleDialogIsCommonChange},model:{value:(_vm.dialogForm.is_common),callback:function ($$v) {_vm.$set(_vm.dialogForm, "is_common", $$v)},expression:"dialogForm.is_common"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v("通用")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0}},[_vm._v("专用")])],1),_vm._v(" "),_c('div',{staticClass:"training-knowledge-form-dialog__tips"},[_vm._v("通用知识库适用于所有用户，专用知识库仅适用于特定客户")])],1),_vm._v(" "),(Number(_vm.dialogForm.is_common) === 0)?_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请选择客户","disabled":_vm.isDialogEditLocked,"query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.dialogForm.customerid),callback:function ($$v) {_vm.$set(_vm.dialogForm, "customerid", $$v)},expression:"dialogForm.customerid"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.saving},on:{"click":_vm.saveTrainingKnowledge}},[_vm._v("保存")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"training-instruction-form"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/training/instruction' }}},[_vm._v("培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.pageTitle))])],1)],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__card"},[_c('div',{staticClass:"training-instruction-form__card-header",on:{"click":function($event){_vm.formExpanded = !_vm.formExpanded}}},[_c('span',[_vm._v("表单")]),_vm._v(" "),_c('i',{class:_vm.formExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.formExpanded),expression:"formExpanded"},{name:"loading",rawName:"v-loading",value:(_vm.detailLoading),expression:"detailLoading"}],ref:"form",staticClass:"training-instruction-form__body",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"0"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('section',{staticClass:"training-instruction-form__section"},[_c('h3',{staticClass:"training-instruction-form__section-title"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"title"}},[_c('el-input',{attrs:{"placeholder":"请输入培训标题","maxlength":"255","show-word-limit":"","clearable":""},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("封面")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"cover_imgs"}},[_c('el-upload',{ref:"coverUpload",staticClass:"training-instruction-form__cover-uploader",attrs:{"action":"","drag":"","auto-upload":false,"show-file-list":false,"accept":"image/jpeg,image/png,image/jpg","disabled":_vm.coverUploading,"on-change":_vm.onCoverChange}},[(_vm.coverPreviewUrl)?_c('div',{staticClass:"training-instruction-form__cover-preview"},[_c('img',{attrs:{"src":_vm.coverPreviewUrl,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__cover-actions"},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){$event.stopPropagation();return _vm.removeCover($event)}}},[_vm._v("移除")])],1)]):_c('div',{staticClass:"training-instruction-form__cover-placeholder"},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__cover-placeholder-text"},[_vm._v("点击上传或拖拽图片到此处")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__cover-placeholder-tip"},[_vm._v("支持 JPG、PNG，建议尺寸 686×292")])])])],1)],1)])]),_vm._v(" "),_c('section',{staticClass:"training-instruction-form__section"},[_c('h3',{staticClass:"training-instruction-form__section-title"},[_vm._v("受众与展示")]),_vm._v(" "),(_vm.isWorkerUser)?[_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("是否在App展示")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"display_in_app_learning_center"}},[_c('el-radio-group',{on:{"change":_vm.onDisplayInAppChanged},model:{value:(_vm.form.display_in_app_learning_center),callback:function ($$v) {_vm.$set(_vm.form, "display_in_app_learning_center", $$v)},expression:"form.display_in_app_learning_center"}},_vm._l((_vm.opts.boolMaps),function(it){return _c('el-radio',{key:it.value,attrs:{"label":Number(it.value)}},[_vm._v(_vm._s(it.label))])}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("优先级")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"priority"}},[_c('el-input-number',{staticClass:"training-instruction-form__number-input",attrs:{"min":0,"precision":0,"controls-position":"right"},model:{value:(_vm.form.priority),callback:function ($$v) {_vm.$set(_vm.form, "priority", $$v)},expression:"form.priority"}}),_vm._v(" "),_c('div',{staticClass:"field-tip"},[_vm._v("在 App 学习中心内的展示顺序，数字越小优先级越高")])],1)],1)]),_vm._v(" "),(_vm.showLearningCenterGroup)?_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label"},[_vm._v("学习中心内所属分组")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"instruction_group_name"}},[_c('el-select',{staticClass:"width-max",attrs:{"filterable":"","allow-create":"","clearable":"","popper-class":"training-instruction-group-select","placeholder":"请选择或者新建分组"},model:{value:(_vm.form.instruction_group_name),callback:function ($$v) {_vm.$set(_vm.form, "instruction_group_name", $$v)},expression:"form.instruction_group_name"}},_vm._l((_vm.instructionGroups),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.label}},[_c('span',{staticClass:"instruction-group-option"},[_c('span',{staticClass:"instruction-group-option__label"},[_vm._v(_vm._s(item.label)+" / "+_vm._s(item.value))]),_vm._v(" "),_c('el-button',{staticClass:"instruction-group-option__delete",attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteInstructionGroup(item)}}})],1)])}),1),_vm._v(" "),_c('div',{staticClass:"field-tip"},[_vm._v("仅用在 App 学习中心内筛选")])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.needsExam)?_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("重考间隔（天）")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"retraining_days"}},[_c('div',{staticClass:"training-instruction-form__inline-number"},[_c('el-input-number',{staticClass:"training-instruction-form__number-input",attrs:{"min":0,"precision":0,"controls-position":"right"},model:{value:(_vm.form.retraining_days),callback:function ($$v) {_vm.$set(_vm.form, "retraining_days", $$v)},expression:"form.retraining_days"}}),_vm._v(" "),_c('span',{staticClass:"training-instruction-form__inline-suffix"},[_vm._v("天")])],1),_vm._v(" "),_c('div',{staticClass:"field-tip"},[_vm._v("0 表示培训一次永久有效")])])],1)]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('section',{staticClass:"training-instruction-form__section"},[_c('h3',{staticClass:"training-instruction-form__section-title"},[_vm._v("内容配置")]),_vm._v(" "),(_vm.isContentConfigLocked)?_c('el-alert',{staticClass:"content-lock-alert",attrs:{"type":"info","closable":false,"show-icon":"","title":"培训非新创建状态，所属用户类型、是否通用、所属客户、所属知识库、类型、关联教程、关联考试不可修改"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("是否通用")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"is_common"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isContentConfigLocked},on:{"change":_vm.onIsCommonChanged},model:{value:(_vm.form.is_common),callback:function ($$v) {_vm.$set(_vm.form, "is_common", $$v)},expression:"form.is_common"}},_vm._l((_vm.opts.isCommonMaps),function(it){return _c('el-radio',{key:it.value,attrs:{"label":it.value}},[_vm._v(_vm._s(it.label))])}),1)],1)],1)]),_vm._v(" "),(_vm.form.is_common === _vm.consts.IS_COMMON_DEDICATED)?_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("所属客户")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请输入客户名称/编号搜索","disabled":_vm.isContentConfigLocked,"query-request":_vm.getBasicCustomerTable,"find-request":_vm.getBasicCustomerDetail},on:{"change":_vm.onContentConfigChanged},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("所属知识库")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"training_knowledge_id"}},[_c('div',{staticClass:"training-instruction-form__field-with-action"},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"name","label-key":"name","placeholder":"请输入知识库名称搜索","disabled":_vm.isContentConfigLocked || (_vm.form.is_common === _vm.consts.IS_COMMON_DEDICATED && !_vm.form.customerid),"query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge,"query-params":_vm.knowledgeQueryParams},model:{value:(_vm.form.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.form, "training_knowledge_id", $$v)},expression:"form.training_knowledge_id"}}),_vm._v(" "),(!_vm.isContentConfigLocked)?_c('el-tooltip',{attrs:{"content":"新建知识库","placement":"top"}},[_c('el-button',{staticClass:"training-instruction-form__field-action",attrs:{"type":"text","icon":"el-icon-circle-plus-outline"},on:{"click":_vm.openKnowledgeDialog}})],1):_vm._e()],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{staticClass:"training-instruction-form__label is-required"},[_vm._v("类型")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"instruction_type"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isContentConfigLocked},on:{"change":_vm.onInstructionTypeChanged},model:{value:(_vm.form.instruction_type),callback:function ($$v) {_vm.$set(_vm.form, "instruction_type", $$v)},expression:"form.instruction_type"}},_vm._l((_vm.opts.typeMaps),function(it){return _c('el-radio',{key:it.value,attrs:{"label":Number(it.value)}},[_vm._v(_vm._s(it.label))])}),1)],1)],1)]),_vm._v(" "),(_vm.needsCourse)?_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{class:['training-instruction-form__label', { 'is-required': _vm.needsCourse }]},[_vm._v("关联教程")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"training_course_id"}},[_c('div',{staticClass:"training-instruction-form__field-with-action"},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"title","label-key":"title","placeholder":"请输入教程标题搜索","disabled":_vm.isContentConfigLocked,"query-request":_vm.queryUserTrainingCourse,"query-params":Object.assign({}, _vm.relatedContentQueryParams, {status: _vm.courseConsts.STATUS_ONLINE}),"find-request":_vm.getTrainingCourse},model:{value:(_vm.form.training_course_id),callback:function ($$v) {_vm.$set(_vm.form, "training_course_id", $$v)},expression:"form.training_course_id"}}),_vm._v(" "),(!_vm.isContentConfigLocked)?_c('el-tooltip',{attrs:{"content":"新建教程","placement":"top"}},[_c('el-button',{staticClass:"training-instruction-form__field-action",attrs:{"type":"text","icon":"el-icon-circle-plus-outline"},on:{"click":_vm.goCreateCourse}})],1):_vm._e()],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.needsExam)?_c('div',{staticClass:"training-instruction-form__row"},[_c('label',{class:['training-instruction-form__label', { 'is-required': _vm.needsExam }]},[_vm._v("关联考试")]),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__field"},[_c('el-form-item',{staticClass:"training-instruction-form__form-item",attrs:{"prop":"training_examination_id"}},[_c('div',{staticClass:"training-instruction-form__field-with-action"},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","keyword-key":"title","label-key":"title","placeholder":"请输入考试标题搜索","disabled":_vm.isContentConfigLocked,"query-request":_vm.queryTrainingExamination,"query-params":Object.assign({}, _vm.relatedContentQueryParams, {status: _vm.consts.EXAMINATION_STATUS_ONLINE}),"find-request":_vm.getTrainingExamination},model:{value:(_vm.form.training_examination_id),callback:function ($$v) {_vm.$set(_vm.form, "training_examination_id", $$v)},expression:"form.training_examination_id"}}),_vm._v(" "),(!_vm.isContentConfigLocked)?_c('el-tooltip',{attrs:{"content":"新建考试","placement":"top"}},[_c('el-button',{staticClass:"training-instruction-form__field-action",attrs:{"type":"text","icon":"el-icon-circle-plus-outline"},on:{"click":_vm.goCreateExamination}})],1):_vm._e()],1)])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"training-instruction-form__footer"},[_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","native-type":"submit","loading":_vm.submitting}},[_vm._v(_vm._s(_vm.submitButtonText))])],1)])],1),_vm._v(" "),_c('training-knowledge-form-dialog',{ref:"knowledgeDialog",on:{"success":_vm.onKnowledgeCreated}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/training-instruction-form.6b435e6e47ac9b8ad521.js